import React, { useEffect } from "react";
import { useCountdown } from "../../../common/hooks/useCountdown";
import DisplayDigits from "./DisplayDigits";

function CountdownTimer({ countdownTo, offset, string, refresh, setRefresh }) {
  const [days, hours, minutes, seconds] = useCountdown(countdownTo, offset);

  useEffect(() => {
    if (seconds < 0) {
      refresh ? setRefresh(false) : setRefresh(true);
    }
  }, [seconds]);

  return (
    <div /* style={{ Width: "250px" }} */>
      <div className="is-flex is-flex-direction-column">
        <div className="is-size-7 has-text-left">{string}</div>
        <div className="is-flex is-flex-direction-row ">
          {/* Days */}
          <DisplayDigits digits={!days ? 0 : days < 0 ? 0 : days} text={"dana"} />
          {/* Hours */}
          <DisplayDigits digits={!hours ? 0 : hours < 0 ? 0 : hours} text={"sati"} />
          {/* Minutes */}
          <DisplayDigits digits={!minutes ? 0 : minutes < 0 ? 0 : minutes} text={"minuta"} />
          {/* Seconds */}
          <DisplayDigits digits={!seconds ? 0 : seconds < 0 ? 0 : seconds} text={"sekundi"} />
        </div>
      </div>

      {/* <div className={"is-flex is-flex-direction-row is-size-7 is-justify-content-space-between"}>
        <p className="ml-3">dana</p>
        <p className="ml-4">sati</p>
        <p className="ml-3">minuta</p>
        <p className="mr-1">sekundi</p>
      </div> */}
    </div>
  );
}

export default CountdownTimer;
